module.exports = __webpack_public_path__ + "media/images/icon-customer-centric-strategy-e15390a14c2a1c0b3c4c115f303a99d8.svg";